import { createSlice } from "@reduxjs/toolkit";
import {
  DraftOrdersListAPI,
  FailedOrdersListAPI,
  OrderRequestsList,
  OrdersListAPI,
} from "../../actions/adminActions/listsAction";

const initialState = {
  all_order_request_list: [],
  all_orders_list: [],
  all_failed_orders_list: [],
  all_draft_orders_list: [],
};

const AllLists = createSlice({
  name: "allOrderRequest",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    // order requests list
    builder.addCase(OrderRequestsList.fulfilled, (state, { payload }) => {
      console.log("All Order Request List fetched is:", payload);
      state.all_order_request_list = payload?.data?.data;
    });
    builder.addCase(OrderRequestsList.rejected, (state, action) => {
      console.error(
        "Fetch All Order Request List failed:",
        action.error.message
      );
    });

    // orders list
    builder.addCase(OrdersListAPI.fulfilled, (state, { payload }) => {
      console.log("All Orders List fetched is:", payload);
      state.all_orders_list = payload?.data?.data;
    });
    builder.addCase(OrdersListAPI.rejected, (state, action) => {
      console.error("Fetch All Orders List failed:", action.error.message);
    });

    // failed orders list
    builder.addCase(FailedOrdersListAPI.fulfilled, (state, { payload }) => {
      state.all_failed_orders_list = payload?.data?.data;
      console.log(
        "All Failed Orders List fetched is:",
        state.all_failed_orders_list
      );
    });
    builder.addCase(FailedOrdersListAPI.rejected, (state, action) => {
      console.error(
        "Fetch All Failed Orders List failed:",
        action.error.message
      );
    });

    // draft orders list
    builder.addCase(DraftOrdersListAPI.fulfilled, (state, { payload }) => {
      state.all_draft_orders_list = payload?.data?.data;
      console.log(
        "All Draft Orders List fetched is:",
        state.all_draft_orders_list
      );
    });
    builder.addCase(DraftOrdersListAPI.rejected, (state, action) => {
      console.error(
        "Fetch All Draft Orders List failed:",
        action.error.message
      );
    });
  },
});

export default AllLists.reducer;
